
import {
  LOAD_HB_INDEX_ERROR,
  LOAD_HB_INDEX_SUCCESS,
  LOAD_PRIMARY_EMOTIONS_BREAKDOWN_ERROR,
  LOAD_PRIMARY_EMOTIONS_BREAKDOWN_REQUEST, LOAD_PRIMARY_EMOTIONS_BREAKDOWN_SUCCESS, LOAD_RESPONSES_INFO_ERROR,
  LOAD_RESPONSES_INFO_SUCCESS,
  LOAD_SENTIMENT_BREAKDOWN_ERROR,
  LOAD_SENTIMENT_BREAKDOWN_REQUEST, LOAD_SENTIMENT_BREAKDOWN_SUCCESS, LOAD_TOP_WORDS_ERROR, LOAD_TOP_WORDS_REQUEST,
  LOAD_TOP_WORDS_SUCCESS
} from "./charts-action-types";

const initialState = {
  topWordsLoading: false,
  topWords: [],
  topWordsError: "",
  sentimentBreakdown: [],
  sentimentBreakdownLoading: false,
  sentimentBreakdownError: "",
  primaryEmotionsBreakdown: [],
  primaryEmotionsBreakdownLoading: false,
  primaryEmotionsBreakdownError: "",
  responsesInfo: {},
  responsesInfoError: "",
  hbIndex: null,
  hbIndexError: "",
  whoMountedTopWords: null,
  whoMountedSentiment: null,
  whoMountedPrimary: null
};

export default ( state = initialState, action ) => {
  const {
    topWords,
    error,
    sentimentBreakdown,
    primaryEmotionsBreakdown,
    responsesInfo,
    hbIndex,
    reportUrl
  } = action;

  switch(action.type) {

    case LOAD_HB_INDEX_SUCCESS:
      return {
        ...state,
        hbIndex,
        hbIndexError: ""
      };

    case LOAD_HB_INDEX_ERROR:
      return {
        ...state,
        hbIndexError: error
      };

    case LOAD_RESPONSES_INFO_SUCCESS:
      return {
        ...state,
        responsesInfo,
        responsesInfoError: ""
      };

    case LOAD_RESPONSES_INFO_ERROR:
      return {
        ...state,
        responsesInfoError: error
      };

    case LOAD_PRIMARY_EMOTIONS_BREAKDOWN_REQUEST:
      return {
        ...state,
        primaryEmotionsBreakdownLoading: true,
        whoMountedPrimary: reportUrl,
        primaryEmotionsBreakdownError: ""
      };

    case LOAD_PRIMARY_EMOTIONS_BREAKDOWN_SUCCESS:
      return {
        ...state,
        primaryEmotionsBreakdown,
        primaryEmotionsBreakdownLoading: false,
        primaryEmotionsBreakdownError: ""
      };

    case LOAD_PRIMARY_EMOTIONS_BREAKDOWN_ERROR:
      return {
        ...state,
        primaryEmotionsBreakdownError: error,
        primaryEmotionsBreakdown: [],
        primaryEmotionsBreakdownLoading: false
      };

    case LOAD_SENTIMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        sentimentBreakdown,
        sentimentBreakdownError: "",
        sentimentBreakdownLoading: false
      };

    case LOAD_SENTIMENT_BREAKDOWN_ERROR:
      return {
        ...state,
        error,
        sentimentBreakdownLoading: false,
        sentimentBreakdownError: error,
        sentimentBreakdown: []
      };

    case LOAD_SENTIMENT_BREAKDOWN_REQUEST:
      return {
        ...state,
        sentimentBreakdownLoading: true,
        sentimentBreakdownError: "",
        whoMountedSentiment: reportUrl,
      };

    case LOAD_TOP_WORDS_REQUEST:
      return {
        ...state,
        topWordsLoading: true,
        topWordsError: "",
        responsesInfoError: "",
        whoMountedTopWords: reportUrl,
      };

    case LOAD_TOP_WORDS_SUCCESS:
      return {
        ...state,
        topWordsLoading: false,
        topWords,
        topWordsError: '',
        responsesInfoError: ""
      };

    case LOAD_TOP_WORDS_ERROR:
      return {
        ...state,
        topWordsLoading: false,
        topWordsError: error,
        topWords: []
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/charts/charts-reducer.js